const loadingIndicators = document.querySelectorAll(".loading-indicator");
let isLoading = false;
let consecutiveFailures = 0;
// First Server render will return Page one so we start at Page 2
let currentPage = 2;
let totalPages = null

const toggleLoadingIndicator = (show) => {
    if (!loadingIndicators || loadingIndicators.length === 0) return;

    loadingIndicators.forEach(indicator => {
        indicator.classList.toggle("hidden", !show);
    });
}

async function fetchFacilities(area, trainingforms, conveniences, lat, lng) {
    if (isLoading) return null;

    isLoading = true;
    toggleLoadingIndicator(true);

    // Build query parameters
    const params = new URLSearchParams({
        language: getLanguage(),
        page: currentPage
    });

    if (lat) params.append("latitude", parseFloat(lat));
    if (lng) params.append("longitude", parseFloat(lng));
    if (area) params.append("search", area);
    if (trainingforms && trainingforms.length > 0) {
        trainingforms.forEach(tf => params.append("workouts", tf));
    }
    if (conveniences && conveniences.length > 0) {
        conveniences.forEach(c => params.append("conveniences", c));
    }

    try {
        const response = await fetch(`/api/FindFacilityApi/GetList?${params.toString()}`, {
            headers: {
                'Accept': 'application/json',
            }
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        if (data.page >= data.totalPages || currentPage >= data.totalPages) {
            showButtonFunction(true)
        }

        currentPage++;
        totalPages = data.totalPages;
        return data;
    } catch (error) {
        consecutiveFailures++;
        if (consecutiveFailures >= 3) showButtonFunction(true);
        console.error("Error fetching facilities:", error);

        // (NOTE) -- this could, and should be improved to view an UI message where Users are informed that the Facilities was not properly loaded & possibly let them try to refetch. --
        return null;
    } finally {
        isLoading = false;
        toggleLoadingIndicator(false);
    }
}
